export default __webpack_public_path__ + "static/media/binary-world.a30c53b5.png";